import React, { lazy, Suspense } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { FlowmodoroProvider } from "./context/FlowmodoroContext";

// Lazy load page components
const Login = lazy(() => import("./pages/Login"));
const ListSchedules = lazy(() => import("./pages/Blocks/Blocks"));
const Home = lazy(() => import("./pages/Home/Home"));
const Stats = lazy(() => import("./pages/Stats/Stats"));
const EditSchedule = lazy(() => import("./pages/EditBlock/EditBlock"));
const Preferences = lazy(() => import("./pages/Preferences/Preferences"));
const Timer = lazy(() => import("./pages/Timer/Timer"));
const GuestTimer = lazy(() => import("./pages/Timer/GuestTimer"));
const Feedback = lazy(() => import("./pages/Feedback/Feedback"));
const Records = lazy(() => import("./pages/Records/Records"));
const Badges = lazy(() => import("./pages/Badges/Badges"));
const BlogEntry = lazy(() => import("./pages/Blog/BlogEntry"));
const Guides = lazy(() => import("./pages/Guides/Guides"));
const Blog = lazy(() => import("./pages/Blog/Blog"));
import { blogs } from "./pages/Blog/blogs";

const App = () => {
  return (
    <>
    <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context" : "https://schema.org",
            "@type" : "WebSite",
            "name" : "Flowmodoro",
            "url" : "https://flowmodoro.com/"
          }),
        }}
      />
      <BrowserRouter>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/try" element={<GuestTimer />} />
            <Route path="/guides" element={<Guides />} />
            <Route
              path="/guides/flowmodoro101"
              element={
                <BlogEntry
                  path="/guides/Guide.md"
                  helmetDescription="An introduction to Flowmodoro."
                  helmetTitle="Flowmodoro 101"
                />
              }
            />
            <Route
              path="/guides/tips-for-creating-blocks"
              element={
                <BlogEntry
                  path="/guides/TipsForCreatingBlocks.md"
                  helmetTitle={"Creating Block Tips"}
                  helmetDescription={"Tips for creating blocks in Flowmodoro."}
                />
              }
            />
            <Route path="/blog" element={<Blog />} />
            {blogs.map((blog) => (
              <Route
                key={blog.urlPath}
                path={blog.urlPath}
                element={
                  <BlogEntry
                    path={blog.markdownPath}
                    helmetTitle={blog.helmetTitle}
                    helmetDescription={blog.helmetDescription}
                  />
                }
              />
            ))}
            <Route element={<FlowmodoroProvider />}>
              <Route path="/blocks" element={<ListSchedules />} />
              <Route path="/stats" element={<Stats />} />
              <Route path="/records" element={<Records />} />
              <Route path="/timer" element={<Timer />} />
              <Route path="/badges" element={<Badges />} />
              <Route
                path="/blocks/edit/:scheduleName"
                element={<EditSchedule />}
              />
              <Route path="/preferences" element={<Preferences />} />
              <Route path="/feedback" element={<Feedback />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </>
  );
};

export default App;
